import { QueryResult, useQuery } from '@apollo/client'
import {
  OneOffPaymentAndObjectivePaymentsWithObjectivesQuery,
  OneOffPaymentAndObjectivePaymentsWithObjectivesQueryVariables,
} from '../../../types'
import { ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES } from '../OneOffPaymentQueries'

export default (
  meetingId: number,
): QueryResult<OneOffPaymentAndObjectivePaymentsWithObjectivesQuery, OneOffPaymentAndObjectivePaymentsWithObjectivesQueryVariables> => {
  return useQuery<OneOffPaymentAndObjectivePaymentsWithObjectivesQuery, OneOffPaymentAndObjectivePaymentsWithObjectivesQueryVariables>(
    ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES,
    {
      variables: {
        meetingId: meetingId,
      },
      fetchPolicy: 'cache-and-network',
    },
  )
}
